<template>
    <div v-if="settings.show">
        <b-modal v-model="showW3Wpopup"
                 :content-class=" 'custom-modal ' + (settings.sectionClass ? settings.sectionClass : '')">
            <div class="main-content">
                <div class="main-icon" @click="onW3WSiteClick">
                    <img src="../../assets/icons/w3w_logo.png">
                </div>
                <div class="main-text">
                    {{translate('w3wTitle')}}
                </div>
            </div>
            <template v-slot:modal-footer>
                <div class="footer-buttons">
                    <div class="white-btn" @click="onW3WSiteClick">{{translate('w3wLearnMore')}}</div>
                    <div class="black-btn" @click="onOkClick">OK</div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import _ from "lodash";

    export default {
        name: "w3wPopup",
        data() {
            return {
                showW3Wpopup: _.isEmpty(this.settings)
            }
        },
        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },
        watch: {
            settings(newValue) {
                this.showW3Wpopup = !_.isEmpty(newValue)
            }
        },
        methods: {
            onW3WSiteClick () {
                window.open('https://what3words.com/about', '_blank')
            },
            onOkClick() {
                this.showW3Wpopup = false
            }
        }
    }
</script>

<style scoped>
    .main-icon {
        margin-top: -35px;
        width: 200px;
        height: 60px;
    }
    .main-content {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .main-text {
        text-align: center;
        width: 300px;
    }
    .black-btn {
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        background-color: #3F405C;
        padding: 12px;
        color: white;
        width: 100%;
        border-radius: 6px;
        cursor: pointer;
    }
    .white-btn {
        cursor: pointer;
        padding: 12px;
        color: #3F405C;
        border: 2px solid #3F405C;
        box-sizing: border-box;
        border-radius: 6px;
        margin-top: 8px;
        margin-bottom: 8px;
    }
    .footer-buttons {
        width: 100%;
    }
</style>